import { Dayjs } from 'dayjs';
import {
  IMappedTeacherSchedule,
  ITeacherSchedule,
  mappedTeacherSchedule,
} from 'entities/types';
import {
  dicsiplTypeToPrettyFormat,
  getParity,
  getWeekDaysBetweenDates,
  isDateInInterval,
  isNeedToShowByWeekParityAndDateTime,
  locationToPrettyFormat,
  makeHash,
  subgroupNumber,
} from 'shared/lib';

export const mapTeacherSchedule = (
  startDate: Dayjs,
  endDate: Dayjs,
  data: ITeacherSchedule[],
): mappedTeacherSchedule => {
  const scheduleMatrix: mappedTeacherSchedule = [];

  const scheduleWeekDays = getWeekDaysBetweenDates(startDate, endDate);

  scheduleWeekDays.forEach((day, index) => {
    if (!scheduleMatrix[index]) {
      scheduleMatrix[index] = [];
    }

    const parity = getParity(day.date.toDate());

    const schedule = data.filter(
      (schedule) => +schedule.daynum === day.dayOfWeek,
    );

    let mapped: IMappedTeacherSchedule;

    if (schedule.length && isDateInInterval(day.date.toDate())) {
      schedule.forEach((item, i) => {
        if (
          isNeedToShowByWeekParityAndDateTime({
            weekParity: parity,
            dayDate: item.daydate,
            searchingDate: day.date.toDate(),
          })
        ) {
          mapped = {
            date: day.date,
            dayDate: item.daydate,
            disciplName: item.disciplname,
            disciplType: dicsiplTypeToPrettyFormat(item.discipltype),
            disciplTime: item.daytime,
            location: locationToPrettyFormat({
              buildNum: item.building,
              audNum: item.auditory,
            }),
            group: item.group,
            groupsTags: item.group_list,
            teacher: item.prepodfio,
            key: makeHash(
              day.date.format('DD.MM.YYYY') +
                i.toString() +
                item.disciplname +
                item.daytime +
                item.daynName +
                item.prepodId +
                item.group +
                item.numDisciplGuide,
            ),
            subgroupNum: subgroupNumber({
              weekParity: parity,
              dayDate: item.daydate,
              searchingDate: day.date.toDate(),
            }),
          };
          scheduleMatrix[index].push(mapped);
        }
      });
    }
  });
  return scheduleMatrix;
};
